import {Progress} from "antd";
import className from "classnames/bind";
import {RATING_COLOR} from "./ratings";
import style from "../style/PageSpeed.module.scss";

const cn = className.bind(style);

const CATEGORIES = [
	{key: 'performance', label: 'Hiệu suất'},
	{key: 'accessibility', label: 'Trợ năng'},
	{key: 'best-practices', label: 'Thực hành tốt'},
	{key: 'seo', label: 'SEO'},
];

/**
 * 4 vòng điểm category Lighthouse (0..100), tô màu theo rating (good/average/poor).
 * scores: {performance:{score,rating}, accessibility, 'best-practices', seo}.
 */
function CategoryScores({scores = {}}) {
	return (
		<div className={cn('scores')}>
			{CATEGORIES.map(({key, label}) => {
				const item = scores[key] || {};
				const score = item.score;
				const color = RATING_COLOR[item.rating] || RATING_COLOR.na;

				return (
					<div className={cn('score-item')} key={key}>
						<Progress
							type="dashboard"
							percent={score ?? 0}
							format={() => (score === null || score === undefined ? '—' : score)}
							strokeColor={color}
							size={108}
						/>
						<div className={cn('score-label')}>{label}</div>
					</div>
				);
			})}
		</div>
	);
}

export default CategoryScores;
